import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMessage2({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 13.71c1.24 0 2.25-1 2.25-2.25v-7c0-1.24-1-2.25-2.25-2.25h-9.5C2.01 2.21 1 3.21 1 4.46v7c0 1.24 1 2.25 2.25 2.25H4.5v1.04a1.25 1.25 0 002.13.89l1.93-1.93h4.19zM6 12.96a.75.75 0 00-.75-.75h-2a.75.75 0 01-.75-.75v-7c0-.41.34-.75.75-.75h9.5c.41 0 .75.34.75.75v7c0 .41-.34.75-.75.75h-4.5c-.2 0-.39.08-.53.22L6 14.15v-1.19zm-1-5.5h6a.75.75 0 000-1.5H5a.75.75 0 000 1.5zm0 2.5h4a.75.75 0 000-1.5H5a.75.75 0 000 1.5z"
      />
    </svg>
  );
}

SvgBasicMessage2.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMessage2.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicMessage2 svgRef={ref} {...props} />);
export default ForwardRef;
